module.exports = __webpack_public_path__ + "static/img/flow-modeler-logo.eff1f89b.svg";